/* eslint-disable jsx-a11y/anchor-is-valid */
import Select from 'react-select'
import { useEffect, useState, useMemo, type KeyboardEvent } from "react";
import { ListPlantsLinked } from "../listPlantsLinked";
import { useToast } from "../../../../../components/Toats";
import { getClientAll } from "../../../../../../services/clientService";
import { getUnitBranchAllSimple } from "../../../../../../services/unitBranchService";
import { getFunnelsAll } from "../../../../../../services/funnels";
import { getCollaboratosAll } from "../../../../../../services/collaboratorsService";
import { getplantsAll } from "../../../../../../services/plantsService";
import { Loading } from "../../../../../components/Loadings/loading";
import { LoadingSpan } from "../../../../../components/Loadings/loadingSpan";
import { KTSVG } from '../../../../../../../_metronic/helpers';


type StepModalProps = {
  data: any
  updateData?: (fieldsToUpdate: Record<string, unknown>) => void
  hasError: boolean
  formik: any
  clientsReloadToken?: number
  newClientIdToSelect?: string
  onAppliedNewClientSelection?: () => void
  onOpenNewClientModal?: () => void
}

const handleSelectBackspaceKey = (e: KeyboardEvent) => {
  if (e.key === 'Backspace') {
    e.stopPropagation()
  }
}

const handleFormBackspaceKey = (e: KeyboardEvent<HTMLDivElement>) => {
  if (e.key !== 'Backspace') return
  const target = e.target as HTMLElement
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
    e.stopPropagation()
    return
  }
  e.preventDefault()
}

const StepModal = ({
  data,
  updateData: _updateData,
  hasError,
  formik,
  clientsReloadToken = 0,
  newClientIdToSelect,
  onAppliedNewClientSelection,
  onOpenNewClientModal,
}: StepModalProps) => {

  const [plants, setPlants] = useState<any[]>([]);
  const [clients, setClients] = useState<any[]>([]);
  const [unitBranchs, setUnitBranchs] = useState<any[]>([]);
  const [funnels, setFunnels] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [largura, setLargura] = useState(window.innerWidth);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingClients, setLoadingClients] = useState<boolean>(false);
  const [loadingUnitBranchs, setLoadingUnitBranchs] = useState<boolean>(false);
  const { toggleToast } = useToast();
  const [loadingFunnels, setLoadingFunnels] = useState(true);
  const [filterPhaseFunnel, setFilterPhaseFunnel] = useState<string>("");
  const [collaborators, setCollaborators] = useState<any[]>([]);
  const [loadingCollaborators, setLoadingCollaborators] = useState<boolean>(false);
  const [datesAparent, setDatesAparent] = useState<boolean>(false);

  useEffect(() => {
    if (formik.values.dateInit || formik.values.dateEnd) {
      setDatesAparent(true)
    }
  }, [formik.values.dateInit, formik.values.dateEnd])


  // const filteredClients = useMemo(() => {
  //   if (!searchClient) return clients
  
  //   return clients.filter((client: any) =>
  //     client.nameResponsible
  //       .toLowerCase()
  //       .includes(searchClient.toLowerCase())
  //   )
  // }, [searchClient, clients])

  const getUsersAllClients = async () => {
    try {
      setLoadingClients(true)
      const MyClient = await getClientAll(formik.values.idUnitBranch ? formik.values.idUnitBranch : "")
      setClients(MyClient)

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar a lista de clients. ", "error")
      
    }finally{
      setLoadingClients(false)
    }
  }

  const getUsersAllUnitBranchs = async () => {
    try {
      setLoadingUnitBranchs(true)
      const unitBranchs = await getUnitBranchAllSimple()
      setUnitBranchs(unitBranchs)

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar a lista de unidades. ", "error")

    }finally{
      setLoadingUnitBranchs(false)
    }
  }

  const getFunnels = async () => {
    try {
      setLoadingFunnels(true)
      const funnels = await getFunnelsAll(formik.values.idUnitBranch ? formik.values.idUnitBranch : "")
      setFunnels(funnels)
      if(funnels){
        funnels.map((funnel: any) => {
          const phaseFunnel = funnel.phasesFunell ? funnel.phasesFunell.find((phaseFunnel: any) => phaseFunnel.id === formik.values.idPhaseFunnel) : null;
          if(phaseFunnel){
            
            setFilterPhaseFunnel(phaseFunnel.description)
          }
        })
      }
      //setFilterPhaseFunnel(funnels.length > 0 ? funnels[0] : {})
    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar os funis. ", "error")
    }finally{
      setLoadingFunnels(false)
    }
  }


  const getUsersAllCollaborators = async () => {
    try {
      setLoadingCollaborators(true)
      const collaboratos = await getCollaboratosAll()
      setCollaborators(collaboratos)

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar os colaboradores. ", "error")

    }finally{
      setLoadingCollaborators(false)
    }
  }

  type FetchPlantsOptions = {
    collaboratorId?: string | null
    clientId?: string | null
    silent?: boolean
  }

  const fetchPlants = async (options?: FetchPlantsOptions) => {
    try {
      if (!options?.silent) {
        setLoading(true)
      }
      const unitBranch = formik.values.idUnitBranch ?? ''
      const collaborator =
        options && 'collaboratorId' in options
          ? (options.collaboratorId ?? '')
          : formik.values.idsCollaborator?.length
            ? formik.values.idsCollaborator[0]
            : ''
      const client =
        options && 'clientId' in options
          ? (options.clientId ?? '')
          : (formik.values.idClient ?? '')

      let plants = await getplantsAll(
        `?unitBranch=${unitBranch}&collaborator=${collaborator}&client=${client}`
      )
      plants = plants.map((plant: any) => {
        plant.imported = false
        return plant
      })
      plants = plants.sort((a: any, b: any) => (b.imported ? 1 : -1))
      setPlants(plants)
    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar as usinas! ", "error")
    } finally {
      if (!options?.silent) {
        setLoading(false)
      }
    }
  }

  const getPlants = () => fetchPlants()
  const atualizarTamanhoDaTela = () => {
    setLargura(window.innerWidth);
  };



  useEffect(() => {
    const fuction_async = async () =>{
      await getUsersAllClients()
      await getUsersAllUnitBranchs()
      await getPlants()
      await getFunnels()
      await getUsersAllCollaborators()
    }
    fuction_async()

    window.addEventListener('resize', atualizarTamanhoDaTela);
    return () => {
      window.removeEventListener('resize', atualizarTamanhoDaTela);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (clientsReloadToken === 0) {
      return
    }
    const run = async () => {
      await getUsersAllClients()
      if (newClientIdToSelect) {
        formik.setFieldValue('idClient', newClientIdToSelect)
        onAppliedNewClientSelection?.()
      }
    }
    void run()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientsReloadToken])

  useEffect(() => {
    fetchPlants()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.idUnitBranch]);

  useEffect(() => {
    getUsersAllClients()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.idUnitBranch]);

  useEffect(() => {
    getFunnels()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.idUnitBranch]);

  // if (loadingFunnels) {
  //   return (
  //     <div style={{display: 'flex', justifyContent: 'center', height: '15rem', alignItems: 'center'}}>
  //       <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
  //     </div>
  //   );
  // }


  // }else{
  //   if(users.length === 0){
  //     return (
  //       <div style={{display: 'flex', justifyContent: 'center', height: '15rem', alignItems: 'center'}}>
  //         <h3 style={{display: "flex", flexDirection: "column"}}>
  //           <span className='text-muted mt-1 fw-semibold fs-7'>Há um problema no cadastro. Tente novamente mais tarde. </span>
  //         </h3>
  //       </div>
  //     )
  //   }
  // }

  const funnelOptions = funnels.map((funnel: any) => ({
    label: funnel.description || 'Não identificado',
    options: funnel.phasesFunell.map((phaseFunnel: any) => ({
      value: phaseFunnel.id,
      label: phaseFunnel.description || 'Não identificado',
    })),
  }))

  return (
    <div
      className='current'
      data-kt-stepper-element='content'
      onKeyDown={handleFormBackspaceKey}
    >
      <div className='w-100'>
        <div style={{display: 'flex', gap: '1rem'}}>

          <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Filial</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Selecione para qual unidade filial essa credencial será vinculada. '
              ></i>
            </label>
            <div className="fv-row">
            <Select
              options={unitBranchs.map((myUnitBranch: any) => ({
                value: myUnitBranch.id,
                label: myUnitBranch.companyName,
              }))}
              value={
                unitBranchs
                  .filter(
                    (myUnitBranch: any) =>
                      myUnitBranch.id === formik.values.idUnitBranch
                  )
                  .map((myUnitBranch: any) => ({
                    value: myUnitBranch.id,
                    label: myUnitBranch.companyName,
                  }))[0] || null
              }
              onChange={(option: any) => {
                const branchId = option?.value ?? null
                formik.setValues({
                  ...formik.values,
                  idUnitBranch: branchId,
                  idClient: null,
                  idPhaseFunnel: null,
                })
                setFilterPhaseFunnel('')
              }}
              onKeyDown={handleSelectBackspaceKey}
              placeholder='Selecione a filial'
              isLoading={loadingUnitBranchs}
              isDisabled={loadingUnitBranchs}
              noOptionsMessage={() => 'Nenhuma filial encontrada'}
              loadingMessage={() => 'Carregando...'}
              isClearable
              styles={{
                control: (base, state) => ({
                  ...base,
                  minHeight: '43px',
                  borderColor: state.isFocused ? '#009ef7' : '#dbdfe9',
                  boxShadow: 'none',
                  '&:hover': {
                    borderColor: '#009ef7',
                  },
                }),

                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                  borderRadius: '0.475rem',
                  overflow: 'hidden',
                }),

                menuList: (base) => ({
                  ...base,
                  paddingTop: 0,
                  paddingBottom: 0,
                }),

                option: (base, state) => ({
                  ...base,
                  fontSize: '14px',
                  padding: '10px 16px',
                  backgroundColor: state.isFocused
                    ? '#f5f8fa'
                    : state.isSelected
                    ? '#eef6ff'
                    : '#fff',
                  color: '#3f4254',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f1f1f1',
                }),

                singleValue: (base) => ({
                  ...base,
                  color: '#181c32',
                }),
              }}
            />
              {!formik.values.idUnitBranch && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    Escolha a unidade filial vinculada à proposta.
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Cliente</span>

              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Selecione para qual cliente será o serviço.'
              ></i>
            </label>

            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <Select
                  options={clients.map((client: any) => ({
                    value: client.id,
                    label: client.nameResponsible,
                  }))}
                  value={
                    clients
                      .filter((client: any) => client.id === formik.values.idClient)
                      .map((client: any) => ({
                        value: client.id,
                        label: client.nameResponsible,
                      }))[0] || null
                  }
                  onChange={(option: any) => {
                    const clientId = option?.value ?? null
                    formik.setFieldValue('idClient', clientId)
                    fetchPlants({ clientId, silent: true })
                  }}
                  onKeyDown={handleSelectBackspaceKey}
                  placeholder='Digite o nome do cliente'
                  isLoading={loadingClients}
                  isDisabled={loadingClients || !formik.values.idUnitBranch}
                  noOptionsMessage={() => 'Nenhum cliente encontrado'}
                  loadingMessage={() => 'Carregando...'}
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '43px',
                      borderColor: '#dbdfe9',
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              </div>
              {onOpenNewClientModal && (
                <button
                  type='button'
                  onClick={onOpenNewClientModal}
                  className='btn btn-sm btn-light-primary flex-shrink-0'
                  style={{ marginTop: '2px' }}
                  disabled={!formik.values.idUnitBranch}
                  title={
                    !formik.values.idUnitBranch
                      ? 'Selecione a filial antes'
                      : 'Cadastrar novo cliente'
                  }
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  Novo Cliente
                </button>
              )}
            </div>

            {!formik.values.idClient && hasError && (
              <div className='fv-plugins-message-container'>
                <div
                  data-field='appname'
                  data-validator='notEmpty'
                  className='fv-help-block'
                >
                  Selecione o cliente!
                </div>
              </div>
            )}
          </div>

          <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Etapa no Funil</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Digite um nome para a unidade(filial)'
              ></i>
            </label>
            
            <div style={{width: '100%'}}>
              <Select
                options={funnelOptions}
                value={
                  funnelOptions
                    .flatMap((group: any) => group.options)
                    .find(
                      (option: any) =>
                        option.value === formik.values.idPhaseFunnel
                    ) || null
                }
                onChange={(option: any) => {
                  setFilterPhaseFunnel(option?.label || '')
                  formik.setFieldValue('idPhaseFunnel', option?.value ?? null)
                }}
                onKeyDown={handleSelectBackspaceKey}
                placeholder='Selecione a etapa do funil'
                isLoading={loadingFunnels}
                noOptionsMessage={() => 'Nenhuma etapa encontrada'}
                loadingMessage={() => 'Carregando...'}
                isClearable
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: '43px',
                    borderColor: state.isFocused ? '#009ef7' : '#dbdfe9',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#009ef7',
                    },
                  }),
                
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    borderRadius: '0.475rem',
                    overflow: 'hidden',
                  }),
                
                  menuList: (base) => ({
                    ...base,
                    paddingTop: 0,
                    paddingBottom: 0,
                  }),
                
                  group: (base) => ({
                    ...base,
                    paddingTop: 0,
                    paddingBottom: 8,
                  }),
                
                  groupHeading: (base) => ({
                    ...base,
                    fontSize: '13px',
                    fontWeight: 700,
                    color: '#181c32',
                    background: '#f5f8fa',
                    padding: '10px 12px',
                    marginBottom: 0,
                    textTransform: 'uppercase',
                    borderBottom: '1px solid #eff2f5',
                  }),
                
                  option: (base, state) => ({
                    ...base,
                    fontSize: '14px',
                    padding: '10px 16px',
                    backgroundColor: state.isFocused
                      ? '#f5f8fa'
                      : state.isSelected
                      ? '#eef6ff'
                      : '#fff',
                    color: '#3f4254',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f1f1f1',
                  }),
                
                  singleValue: (base) => ({
                    ...base,
                    color: '#181c32',
                  }),
                }}
              />
              {!formik.values.idPhaseFunnel && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    Escolha em qual funil e etapa a proposta começará.
                  </div>
                </div>
              )}
              
            </div>
          </div>
        </div>

        <div style={{display: 'flex', gap: '1rem'}}>
          <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Titulo</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Digite um nome para a unidade(filial)'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg'
              name='title'
              placeholder=''
              value={formik.values.title ?? ''}
              onChange={formik.handleChange("title")}
              onKeyDown={handleSelectBackspaceKey}
            />
        
            {!formik.values.title && hasError && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  Informe um título
                </div>
              </div>
            )}
          </div>

          <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Colaborador / Vendedor</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Selecione para qual o colaborador da O.S. '
              ></i>
            </label>
            <div>
            <Select
              options={collaborators.map((collaborator: any) => ({
                value: collaborator.id,
                label: collaborator.name,
              }))}

              value={
                collaborators
                  .filter(
                    (collaborator: any) =>
                      collaborator.id ===
                      (
                        formik.values.idsCollaborator &&
                        formik.values.idsCollaborator.length > 0
                          ? formik.values.idsCollaborator[0]
                          : ''
                      )
                  )
                  .map((collaborator: any) => ({
                    value: collaborator.id,
                    label: collaborator.name,
                  }))[0] || null
              }

              onChange={(option: any) => {
                const collaboratorId = option?.value ?? null
                formik.setFieldValue(
                  'idsCollaborator',
                  collaboratorId ? [collaboratorId] : []
                )
                fetchPlants({ collaboratorId, silent: true })
              }}
              onKeyDown={handleSelectBackspaceKey}
              placeholder='Digite o nome do Colaborador / Vendedor'
              isLoading={loadingCollaborators}
              isDisabled={loadingCollaborators}
              isSearchable
              noOptionsMessage={() =>
                'Nenhum Colaborador / Vendedor encontrado'
              }
              loadingMessage={() => 'Carregando...'}
              isClearable

              styles={{
                control: (base, state) => ({
                  ...base,
                  minHeight: '43px',
                  borderColor: state.isFocused ? '#009ef7' : '#dbdfe9',
                  boxShadow: 'none',
                  '&:hover': {
                    borderColor: '#009ef7',
                  },
                }),

                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                  borderRadius: '0.475rem',
                  overflow: 'hidden',
                }),

                menuList: (base) => ({
                  ...base,
                  paddingTop: 0,
                  paddingBottom: 0,
                }),

                option: (base, state) => ({
                  ...base,
                  fontSize: '14px',
                  padding: '10px 16px',
                  backgroundColor: state.isFocused
                    ? '#f5f8fa'
                    : state.isSelected
                    ? '#eef6ff'
                    : '#fff',
                  color: '#3f4254',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f1f1f1',
                }),

                singleValue: (base) => ({
                  ...base,
                  color: '#181c32',
                }),
              }}
            />
              
              {/* {!data.idUnitBranch && hasError && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  Selecione o colaborador!
                </div>
              </div>
            )} */}
            </div>
          </div>

          {/* <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                <span >Descrição</span>
                <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Descreva com mais detalhes o serviço'
                ></i>
            </label>
            <input
                style={{height: '20rem'}}
                type='text'
                className='form-control form-control-lg'
                name='description'
                placeholder=''
                value={formik.values.description ? formik.values.description : ""}
                onChange={formik.handleChange("description")}
            />
          </div> */}
        </div>

        <div style={{display: 'flex', flexDirection: 'column', gap: '0.5rem'}}>
          
          <label className='d-flex align-items-center gap-2 fs-5 fw-semibold mb-2'>
              <span >Período da Proposta</span>
              <label className='form-check form-check-inline form-check-primary form-check-solid'>
                <input
                  className={`form-check-input ${datesAparent ? 'bg-primary' : 'bg-secondary'}`}
                  name='communication[]'
                  type='checkbox'
                  //defaultChecked={true}
                  checked={datesAparent}
                  onChange={(e) =>{
                    setDatesAparent(e.target.checked);
                  }}
                  
                />
            </label>
          </label>

          {datesAparent && 
            <div style={{display: 'flex', gap: '1rem'}}>
              <div className='fv-row mb-10' style={{flex: '1', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span className='required'>Início</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Digite um nome para a unidade(filial)'
                  ></i>
                </label>
                <input
                  type='datetime-local'
                  className='form-control form-control-lg'
                  name='dateInit'
                  placeholder=''
                  value={formik.values.dateInit ?? ''}
                  onChange={formik.handleChange("dateInit")}
                  onKeyDown={handleSelectBackspaceKey}
                />
                {/* {!formik.values.companyName && hasError && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      Informe uma data de inicio
                    </div>
                  </div>
                )} */}
              </div>

              <div className='fv-row mb-10' style={{flex: '1', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span className='required'>Término</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Digite um nome para a unidade(filial)'
                  ></i>
                </label>
                <input
                  type='datetime-local'
                  className='form-control form-control-lg'
                  name='dateEnd'
                  value={formik.values.dateEnd ?? ''}
                  onChange={formik.handleChange("dateEnd")}
                  onKeyDown={handleSelectBackspaceKey}
                />
                {/* {!formik.values.companyName && hasError && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      Informe um nome para o cliente
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          }
        </div>

        <div>
          <div 
              style={{flex: '3'}}
              className={largura < 1200 ? "tab-pane fade show divTableReport" : ""}
              id="user"
              role="tabpanel"
            >
              {loading 
                ? <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>  
                : <ListPlantsLinked plants={plants} className="className='card-xl-stretch bg-body mb-xl-8" formik={formik}/>
              }
          </div>
          
        </div>
        {/* 
          <div style={{display: 'flex', gap: '1rem'}}>
            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>CPF</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Digite o CPF da Unidade (Filial)'
                ></i>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='cpfResponsible'
                placeholder='000.000.000-00'
                value={formik.values.cpfResponsible}
                onChange={formik.handleChange("cpfResponsible")}
              />
              {!formik.values.cnpj && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    o CPF é obrigatório!
                  </div>
                </div>
              )}
            </div>

            <div className='fv-row mb-10'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Telefone</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Digite um telefone para a cliente'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='telephone'
              placeholder='0000-0000'
              value={formik.values.telephone}
              onChange={formik.handleChange("telephone")}
            />
            </div>
            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span>Celular</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Digite um celular para o cliente'
                ></i>
              </label>
              <input
                type='url'
                className='form-control form-control-lg form-control-solid'
                name='cellphone'
                placeholder='(00) 0 0000-0000'
                value={formik.values.cellphone}
                onChange={formik.handleChange("cellphone")}
              />
            </div>
          </div> */}
          
      </div>
    </div>
  )
}

export {StepModal}

